import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Eye, FileText } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import SEO from '../components/SEO';

const Privacy = () => {
    const { language } = useLanguage();

    const texts = {
        tr: {
            title: 'Gizlilik Politikası',
            lastUpdated: 'Son Güncelleme: 25 Mart 2026',
            sections: [
                {
                    title: '1. Veri Toplama',
                    content: 'Cplus Media LLC olarak, hizmetlerimizi sunabilmek için adınız, e-posta adresiniz, telefon numaranız ve ödeme bilgileriniz gibi kişisel bilgileri topluyoruz.'
                },
                {
                    title: '2. Veri Kullanımı',
                    content: 'Toplanan veriler; hizmet sağlamak, ödemeleri işlemek, sizinle iletişim kurmak ve kullanıcı deneyimini iyileştirmek amacıyla kullanılır.'
                },
                {
                    title: '3. Veri Güvenliği',
                    content: 'Verilerinizin güvenliğini sağlamak için endüstri standardı şifreleme ve güvenlik önlemleri uyguluyoruz. Ödeme bilgileri doğrudan güvenli ödeme sağlayıcımız (Stripe) tarafından işlenir.'
                },
                {
                    title: '4. Çerezler',
                    content: 'Sitemizde size daha iyi hizmet sunabilmek için çerezler kullanmaktayız.'
                }
            ]
        },
        en: {
            title: 'Privacy Policy',
            lastUpdated: 'Last Updated: March 25, 2026',
            sections: [
                {
                    title: '1. Data Collection',
                    content: 'At Cplus Media LLC, we collect personal information such as your name, email address, phone number, and payment information to provide our services.'
                },
                {
                    title: '2. How We Use Data',
                    content: 'The collected data is used to provide services, process payments, communicate with you, and improve the user experience.'
                },
                {
                    title: '3. Data Security',
                    content: 'We implement industry-standard encryption and security measures to ensure the security of your data. Payment information is processed directly by our secure payment provider (Stripe).'
                },
                {
                    title: '4. Cookies',
                    content: 'We use cookies on our site to provide you with better service.'
                }
            ]
        }
    };

    const t = texts[language] || texts.tr;

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-950 py-20">
            <SEO 
                title={t.title}
                description="Cplus Media LLC Privacy Policy"
            />
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="bg-white dark:bg-gray-900 rounded-3xl p-8 md:p-12 shadow-xl border border-gray-200 dark:border-gray-800"
                >
                    <div className="flex items-center gap-4 mb-8">
                        <div className="w-12 h-12 bg-blue-100 dark:bg-blue-900/30 rounded-xl flex items-center justify-center text-blue-600 dark:text-blue-400">
                            <Shield className="w-6 h-6" />
                        </div>
                        <div>
                            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">{t.title}</h1>
                            <p className="text-sm text-gray-500 dark:text-gray-400">{t.lastUpdated}</p>
                        </div>
                    </div>

                    <div className="space-y-8">
                        {t.sections.map((section, idx) => (
                            <div key={idx} className="space-y-3">
                                <h2 className="text-xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
                                    <div className="w-1.5 h-1.5 bg-blue-600 rounded-full" />
                                    {section.title}
                                </h2>
                                <p className="text-gray-600 dark:text-gray-400 leading-relaxed text-lg">
                                    {section.content}
                                </p>
                            </div>
                        ))}
                    </div>

                    <div className="mt-12 pt-8 border-t border-gray-100 dark:border-gray-800">
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                            Questions? Contact us at <a href="mailto:info@cplus.com.tr" className="text-blue-600 hover:underline">info@cplus.com.tr</a>
                        </p>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default Privacy;
